<div class="modal-container modal-sm justify-between text-base text-widget md:justify-normal">
    <div class="modal-close-container">
        <bizz-icon
                class="ml-auto block h-5 w-5 text-button md:ml-0"
                (click)="close()"
                iconName="xmark"
                [hover]="true">
        </bizz-icon>
    </div>
    <div class="modal-body h-full w-full">
        <div class="modal-header">
            <h1 class="font-lg text-center text-widget">
                {{ "GenerateWithAI" | translate }}
            </h1>
        </div>
        <hr class="my-6"/>
        <div class="flex flex-col justify-center gap-4 px-5 text-center">

            <div class="w-full">


                <kendo-label class="gap-4 [&>label]:block [&>label]:m-2.5"
                             [ngClass]="(intent.questions <= min) ? 'error' : ''"
                             [text]="numberOfQuestions()">
                    <kendo-slider
                            class="w-full"
                            [showButtons]="false"
                            [min]="min"
                            [max]="max"
                            [(ngModel)]="intent.questions"
                            [largeStep]="5"
                            (ngModelChange)="validate()"
                    >
                    </kendo-slider>
                </kendo-label>
            </div>
            <small [ngClass]="(!isValidInput && intent.questions <= min) ? 'visible' : 'invisible'"
                   class="text-center text-sm text-danger">value must be between {{ min + 1 }}
                and {{ max }}</small>
            <div class="w-full">
                <kendo-label class="gap-4 [&>label]:block [&>label]:m-2.5"
                             [ngClass]="(intent.answersPerQuestion <= min) ? 'error' : ''"
                             [text]="numberOfAnswers()">
                    <kendo-slider
                            class="w-full"
                            [showButtons]="false"
                            [min]="min"
                            [max]="max"
                            [(ngModel)]="intent.answersPerQuestion"
                            [largeStep]="5"
                            (ngModelChange)="validate()"
                    >
                    </kendo-slider>
                </kendo-label>
            </div>
            <small [ngClass]="(!isValidInput && intent.answersPerQuestion <= min) ? 'visible' : 'invisible'"
                   class="text-center text-sm text-danger">value must be between {{ min + 1 }}
                and {{ max }}</small>
        </div>
    </div>


    <div class="modal-buttons">
        <button class="btn save" type="button" [disabled]="!isValidInput" (click)="confirm()">
            <p> {{ 'Generate' | translate }}</p></button>
    </div>
</div>
